var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 26.667V5.04201C3.33301 4.62534 3.50667 4.23634 3.85401 3.87501C4.20134 3.51367 4.58334 3.33301 5.00001 3.33301H26.625C27.0697 3.33301 27.4653 3.51367 27.812 3.87501C28.1593 4.23634 28.333 4.62534 28.333 5.04201V19.958C28.333 20.3747 28.1593 20.7637 27.812 21.125C27.4653 21.4863 27.0697 21.667 26.625 21.667H10L4.54201 27.125C4.29201 27.375 4.02801 27.4373 3.75001 27.312C3.47201 27.1873 3.33301 26.9723 3.33301 26.667ZM11.708 30C11.2913 30 10.9027 29.8193 10.542 29.458C10.1807 29.0973 10 28.7087 10 28.292V24.458H31.125V10H35C35.4167 10 35.7987 10.1807 36.146 10.542C36.4933 10.9027 36.667 11.3053 36.667 11.75V34.958C36.667 35.2913 36.528 35.5137 36.25 35.625C35.972 35.7363 35.708 35.6807 35.458 35.458L30.042 30H11.708Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatOpen);
export default __webpack_public_path__ + "static/media/chat-open.be80a15014c318a595c36cb1e6c55eb0.svg";
export { ForwardRef as ReactComponent };